import type { PaginatedResponse } from 'walden-fast/types/pagination';
import { sortByRequestParams } from 'walden-fast/utils/sorting';

export const paginatedResponse = <Type>(
  items: Type[],
  page?: number,
  pageSize?: number,
): PaginatedResponse<Type> => {
  const first = ((page || 1) - 1) * (pageSize || 5);
  return {
    items: items.slice(first, first + (pageSize || 5)),
    size: items.length,
  };
};

export const sliceByRequestParams = <Item>(items: Item[], request: Request) => {
  const url = new URL(request.url);
  const page = Number(url.searchParams.get('page'));
  const pageSize = Number(url.searchParams.get('pageSize'));
  return paginatedResponse(items, page, pageSize);
};

export const sortAndPaginate = <Item>(
  items: Item[],
  request: Request,
): PaginatedResponse<Item> => {
  const sortedItems = sortByRequestParams(items, request);
  const slicedItems = sliceByRequestParams(sortedItems, request);
  return slicedItems;
};
